<template>
  <header class="md_header md_header--signup">
    <div class="logo">
      <a href="#">
        <img
          :src="`/student_site/imageFile/logo_white.svg`"
          alt=""
        />
      </a>
    </div>
  </header>
</template>
